import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#EB2961" }}>Highlights</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1"
          >
            <p>
              User-friendly, easy-to-navigate and simple interface, with the
              content-centered and informative flow, the website offers a
              meaningful experience. Thorough information and user-oriented
              features and functions, Select delivers the promise of top-notch
              services, support, and training.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center mt-3"
          >
            <StaticImage
              src="../../../images/case-studies/dream-energy/highlights_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={2880}
              height={1383}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
